export const accessorialRequestModalZIndex = 5000;
export const accessorialRequestConfirmationModalZIndex = 5001;
export const userImpersonationModalZIndex = 5000;
export const createChatConversationModalZIndex = 4999;
export const documentUploadModalZIndex = 6000;
export const counterOfferRequestModalZIndex = 5000;
export const counterOfferRequestConfirmationModalZIndex = 5001;
export const tenderToCarrierModalZIndex = 5000;
export const notesModalZIndex = 5000;
